import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';

const exportPdf = (pCabecalho: string[], pData: string[][], pNome: string) => {
  const unit = 'pt';
  const size = 'A4';
  const orientation = 'landscape';

  const doc = new jsPDF(orientation, unit, size);

  doc.setFontSize(15);

  const title = pNome;

  autoTable(doc, { html: '#tabela' });

  autoTable(doc, {
    head: [[...pCabecalho]],
    body: pData,
  });

  doc.save(`${title}.pdf`);
};

export { exportPdf };
